import React from "react";
import shouldShowGlobalBanner from "helpers/should-show-global-banner";
import ImageBanner from "components/image-banner";

const GlobalBanner = ({ globalBannerSettings, path }) => {
    if (!path) return null;

    return (
        shouldShowGlobalBanner(globalBannerSettings?.showOn, path) && (
            <div className="mb-2 md:mb-[12px] md:mt-[1.5em] global-banner">
                <ImageBanner data={globalBannerSettings?.imageBanner} />
            </div>
        )
    );
};

export default GlobalBanner;
